export enum Operation {
    unknow = '',
    add = 'add',
    update = 'update',
};

export interface SearchRequest {
    page?: number;
    limit?: number;
    [key: string]: any;
}
